
/**
 * Setting current variable
 */
var ship_swap_type = "shipping";

/**
 * Confirms if the current page is filterable.
 * @param None;
 * @returns Boolean 
 */
function isFilterable() {
    // Check for option selectors.
    const shipping_selector = $('#sidebar-filter-v-option-receiving-methodshipping');
    const pickup_selector   = $('#sidebar-filter-v-option-receiving-methodpickup');

    if ((shipping_selector.length > 0) && (pickup_selector.length > 0)) {
        return true;
    } else {
        return false;
    }
}

/**
 * Returns an array of the current query parameters.
 * @param None;
 * @returns URLSearchParameters;
 */
function getCurrentQueryParameters() {
    let params = new URLSearchParams(window.location.search);

    return params;
}

/**
 * Returns the current receiving type.
 * @param None;
 * @return String;
 */
function getSelectedReceivingType() {
    // Get the current parameters.
    const queryParams = getCurrentQueryParameters();

    // Search for the receiving type param.
    const receivingMethod = queryParams.get('filter.v.option.receiving method');

    return receivingMethod;
}

/**
 * Set current receiving method and reload the page.
 * @param String receivingMethod;
 * @return None;
 */
function setCurrentReceivingMethod(receivingMethod) {
    const params = getCurrentQueryParameters();

    params.set('filter.v.option.receiving method', receivingMethod);

    // Reflect the changes in the URL and reload the page
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.location.href = newUrl;
}

/**
 * Checks if the current cart has pickup items.
 * @param None;
 * @return Boolean;
 */
function cartHasPickUpItems() {
    // @TODO: Finish.
    return false;
}

/**
 * Show only the shipping items.
 * @param None;
 * @return None;
 */
function showOnlyShippingItems() {
    // Show shipping items only.
    ship_swap_type = "shipping";
    $('.ProductItem__Wrapper:not(:has(span.item-tag.shipping))').closest('.Grid__Cell').hide();
    $('.ProductItem__Wrapper:has(span.item-tag.shipping)').closest('.Grid__Cell').show();
    $('#shipping-only').addClass('selected');
    $('#pickup-only').removeClass('selected');
    $('.ProductListWrapper').show(); 
}

/**
 * Returns the number of Shipping Items
 * @param None
 * @return Integer
 */
function getCountShippingItems() {
    return $('.ProductItem__Wrapper:has(span.item-tag.shipping)').closest('.Grid__Cell').length;
}

/**
 * Returns the number of Pickup Items
 * @param None
 * @return Integer
 */
function getCountPickupItems() {
    return $('.ProductItem__Wrapper:not(:has(span.item-tag.shipping))').closest('.Grid__Cell').length;
}

/**
 * Show only the pickup items.
 * @param None;
 * @return None;
 */
function showOnlyPickupItems() {
    // Show shipping items only.
    ship_swap_type = "pickup";
    $('.ProductItem__Wrapper:has(span.item-tag.shipping)').closest('.Grid__Cell').hide();
    $('.ProductItem__Wrapper:not(:has(span.item-tag.shipping))').closest('.Grid__Cell').show();
    $('#shipping-only').removeClass('selected');
    $('#pickup-only').addClass('selected');
    $('.ProductListWrapper').show(); 
}

/**
 * Checks if PickUp AND Shipping both exist.
 * @param None;
 * @return Boolean;
 */
function hasPickUpAndShipping() {
    const shippingItems = $('.ProductItem__Wrapper:has(span.item-tag.shipping)');
    const pickupItems = $('.ProductItem__Wrapper:not(:has(span.item-tag.shipping))');

    if ((shippingItems.length > 0) && (pickupItems.length > 0)) {
        return true;
    } else {
        return false;
    }
}

/**
 * Loads the current shipping selection.
 */
function shipSwapLoadCurrentSelection() {
    if ((isFilterable()) || (hasPickUpAndShipping())) { 
        if (ship_swap_type == 'shipping') {
            showOnlyShippingItems();
        } else {
            showOnlyPickupItems();
        }
    }
}

/**
 * Function to get the current 'receive' value from the URL
 */
function getReceiveValue() {
    const currentParams = new URLSearchParams(window.location.search);
    return currentParams.get('receive'); // Returns the value or null if not present
  }
  
/**
 * Function to set or update the 'receive' parameter in the URL
 */
function setReceiveValue(newValue) {
    const currentParams = new URLSearchParams(window.location.search);

    // Update the 'receive' parameter
    if (newValue !== null && newValue !== undefined) {
        currentParams.set('receive', newValue);
    } else {
        currentParams.delete('receive');
    }

    // Update the browser's URL without reloading the page
    const newUrl = `${window.location.pathname}?${currentParams.toString()}`;
    window.history.replaceState({}, '', newUrl);
}
  

$(window).on('load',function() {
    // Return early if non-filterable.
    if ($(".swap-wrapper").length == 0) { 
        $('.ProductListWrapper').show(); 
        $('.ProductItem__Wrapper').show(); 
        return false;
    }
    console.log("Continuing");
    $(".swap-wrapper").show();

    // Get param value
    let selectionValue = getReceiveValue();
    
    if (selectionValue != null) {
        if (selectionValue.toLowerCase() == 'shipping') {
            showOnlyShippingItems();
        } else {
            showOnlyPickupItems();
        }
    } else {
        // If cart has pickup items, show pickup items.
        if (cartHasPickUpItems()) {
            // Set param
            setReceiveValue('pickup');
            showOnlyPickupItems();
        } else {
            // Set param
            setReceiveValue('shipping');
            // If not pickup items in cart, show shipping items only.
            showOnlyShippingItems();
        }
    }

    // Pickup Only Button.
    $('#pickup-only').on('click', function() {
        showOnlyPickupItems();

        // Set param
        setReceiveValue('pickup');
    });

    // Shipping Only Button.
    $('#shipping-only').on('click', function() {
        showOnlyShippingItems();

        // Set param
        setReceiveValue('shipping');
    });
});
